import { i18n } from '@/plugins/i18n'
import StatusColumn from './../components/status-column'

const statusTemplate = (row, index, datatable) => {
    let template = new StatusColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'account_number',
        title: i18n.t('label.account_number'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.full_name'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'phone',
        title: i18n.t('label.phone'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'register_date',
        title: i18n.t('label.register_date'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'last_login_time',
        title: i18n.t('label.last_login_time'),
        sortable: true,
        width: 105,
        textAlign: 'center',
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('label.status'),
        template: (row, index, datatable) => {
            return statusTemplate(row, index, datatable)
        },
        width: 130,
        textAlign: 'center',
    },
]